/** PURE_IMPORTS_START ._WebSocketSubject PURE_IMPORTS_END */
import { WebSocketSubject } from './WebSocketSubject';
export var webSocket = WebSocketSubject.create;
//# sourceMappingURL=webSocket.js.map 



//////////////////
// WEBPACK FOOTER
// ./node_modules/rxjs/_esm5/observable/dom/webSocket.js
// module id = 427
// module chunks = 0